import React from 'react';

class CloseButton extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    return (
      <div className="close-button" onClick={this.props.onClick}>
        <i className="rc-icon-close" />
      </div>
    )
  }
}

export default CloseButton;



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/close_button.js
 **/